// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table td.paid-flights,\n.el-table th.paid-flights {\n  width: 10em;\n}\n.el-table td.paid-flights {\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
